export const srpDataLocators = {
    srp_show_unavailable_products: 'srp_show_unavailable_products',
    srp_toggle_switch:'srp_toggle_switch'
};
